import {RootState} from '@/store'
import {CustomerServiceState} from "@/store/modules/customerService/index";
import {GetterTree} from 'vuex'

export const getters: GetterTree<CustomerServiceState, RootState> = {

  getReferralStatusLobby(state): string {
    return state.referralStatusLobbySelection
  }
}